<template>
        <div id='points'>
              <NavTop :title="'分销商:'+name" :showarrow="false"/>
              <div class='content'>
                  <div class="row fc">
                      <span class="hint">日期</span>
                      <span class="dateinput" @click="showStart=true">{{ cstartDate }}</span>
                      <span class="hint">至</span>
                      <span class="dateinput" @click="showEnd=true">{{ cendDate }}</span>
                  </div>

                  <div class="row">

                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="value"
                        label="药品选择"
                        placeholder="点击选择药品"
                        @click="showPicker = true"
                       
                        />
                        <van-popup v-model="showPicker" position="bottom">
                        <van-picker
                           show-toolbar
                           :columns="druglist"
                           @confirm="onConfirm"
                           @cancel="showPicker = false ; value='';cdrugid=''"
                           ref="refDug"
                        />
                        </van-popup>
                        <div @click="getList" class="sxbtn">确认筛选</div>
                    </div>
                    <div class="row">
                      <van-field
                        readonly
                        clickable
                        name="picker2"
                        :value="value2"
                        label="医院选择"
                        placeholder="点击选择医院"
                        @click="showPicker2 = true"
                       
                        />
                        <van-popup v-model="showPicker2" position="bottom">
                        <van-picker
                           show-toolbar
                           :columns="hospitallist"
                           @confirm="onConfirm2"
                           @cancel="showPicker2 = false ; value2='';chosname='';"
                           ref="refHos"
                        />
                        </van-popup>
                        <div @click="getList" class="sxbtn">确认筛选</div>
                  </div>
                  <div class="row mtb">
                     <span class="ntitle ml">药品名</span>
                     <span class="ntitle fr">蜂蜜</span>
                  </div>
                  <div class="rowbig">
                      <div class="rowitem" v-for="item in drugstore" :key="item.drugid" @click="goDetail(item.drugid)">
                          <div class="rowleft">
                            <div class="rowleft_line1">
                               <div class="drugname">{{item.name}}</div>
                               <div class="money" v-show="!needhide">{{item.total}}</div>
                            </div>
                            <div class="rowleft_line2">
                               <div class="drugspec">{{item.spec}}</div>
                               <div class="drugspec fr">数量:{{item.nums}}</div>
                            </div>
                          </div>
                          <div class="rowright" >
                             <span class="rarrow">></span> 
                          </div>
                      </div>
                  </div>
              </div>   

              <div class="bottompart">
                  <div class="leftpart">
                        <span class="totalnums">总数量:{{ allnums }}</span>
                   </div>
                   <div class="rightpart">
                        <span class="rtotal" v-show="!needhide">合计:</span>
                        <span class="rnumber" v-show="!needhide">{{allmoney}}元</span>
                   </div>
              </div>

              <van-popup v-model="showStart" position="bottom">
                    <van-datetime-picker
                        type="date"
                        v-model="startDate"
                        @cancel="showStart = false"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="handleConfirm1"
                    />
              </van-popup>

              <van-popup v-model="showEnd" position="bottom">
                    <van-datetime-picker
                        type="date"
                        v-model="endDate"
                        @cancel="showEnd = false"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="handleConfirm2"
                    />
              </van-popup>
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { Divider ,Button ,Popup,Picker,DatetimePicker,Field  } from 'vant';

export default {
  name: 'points',
  data(){
      return{
        needhide:false,
        showStart:false,
        showEnd:false,
        startDate:'',
        endDate:'',
        cstartDate:"",
        cendDate:"",
        name:'',
        minDate: new Date(2024, 0, 1),
        maxDate: new Date(2050, 1, 1),


         value: '',
         value2:'',
         druglist: [],
         drugmap:[],
         hospitallist:[],
         drugstore:[],
         allmoney:0,
         allnums:0,

         showPicker: false,
         showPicker2:false,

         cdrugid:'',
         chosname:''
      }
  },  
  computed:{
      myStartDate(){
        return this.$store.state.user.myStartDate;
      },
      myEndDate(){
        return this.$store.state.user.myEndDate;
      }
  },
  created(){
      //console.log("my store start:"+this.myStartDate)
      //console.log("mystore end :"+this.myEndDate)
      if(this.myStartDate!=""){
         this.startDate=this.myStartDate
         this.cstartDate=this.myStartDate
      }
      if(this.myEndDate!=""){
        this.endDate=this.myEndDate
        this.cendDate=this.myEndDate
      }

      this.getList()
  },
  methods: {

    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    onConfirm2(value){
      this.value2 = value;
      this.showPicker2 = false;
    },
    getList(){
        if(this.value!=""&&this.value!=undefined){
           let index=this.$refs.refDug.getIndexes()[0];
           this.cdrugid=this.drugmap[index]
        }

        if(this.value2!=""&&this.value2!=undefined){
           this.chosname=this.value2;
        }
         this.$post("/index/getPrizeInfo",{drugid:this.cdrugid,drughospital:this.chosname,startDate:this.startDate,endDate:this.endDate}).then((data)=>{
             if(data.result.success){
                this.druglist=data.result.info.druglist;
                this.drugmap=data.result.info.drugmap;
                this.hospitallist=data.result.info.hospitallist;
                this.name=data.result.info.name
                this.startDate=data.result.info.startDate;
                this.endDate=data.result.info.endDate;
                this.cstartDate=this.startDate;
                this.cendDate=this.endDate;
                this.drugstore=data.result.info.drugstore;
                this.allmoney=data.result.info.totalmoney;
                this.allnums=data.result.info.totalnums;
             }
         })
      },
      goDetail(drugid){
         if(this.startDate==""){
            this.$toast("请选择开始时间")
            return false
         }
         if(this.endDate==""){
            this.$toast("请选择结束时间")
            return false
         }

        this.$go({name:"pointshistory",params:{startDate:this.startDate,endDate:this.endDate,drugid:drugid,hosname:this.chosname}})
      },
      handleConfirm1(value){
          var date = value;
          var seperator1 = "-";
          var month = date.getMonth() + 1;
          var strDate = date.getDate();
          if (month >= 1 && month <= 9) {
          month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
          }
          this.cstartDate =
          date.getFullYear() +
          seperator1 +
          month +
          seperator1 +
          strDate 

          this.startDate=this.cstartDate
          this.showStart=false
          this.$store.commit("setMyStartDate",this.startDate)
          this.getList();
     },
     handleConfirm2(value){
          var date = value;
          var seperator1 = "-";
          var month = date.getMonth() + 1;
          var strDate = date.getDate();
          if (month >= 1 && month <= 9) {
          month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
          }
          this.cendDate =
          date.getFullYear() +
          seperator1 +
          month +
          seperator1 +
          strDate 

          this.endDate=this.cendDate
          this.showEnd=false
          this.$store.commit("setMyEndDate",this.endDate)
          this.getList();
     }
  },
  components:{
      NavTop,
      [Divider.name]:Divider,
      [Button.name]:Button,
      [Popup.name]:Popup,
      [Picker.name]:Picker,
      [DatetimePicker.name]:DatetimePicker,
      [Field.name]:Field
  }
}
</script>
<style scoped>
.fr{margin-right:10px;}
.row{display: flex;flex-flow: row nowrap;border-bottom: 1px dashed #eee;padding: 0.1rem;align-items: center;}
.rowbig{
    display: flex;flex-flow: column nowrap;border-bottom: 1px dashed #eee;padding: 0.3rem;align-items: center;
    background-color: #FFFFFF;
}
.rowitem{
    display: flex;flex-flow: row nowrap;border-bottom: 1px dashed #eee;padding: 0.3rem;align-items: center;
    background-color: #FFFFFF;
    min-height:2rem;
    width:100%;
    border-bottom:1px solid #eeeeee;
}
.rowleft{
    display:flex;
    flex-flow: column nowrap;
    width:100%;
}
.rowleft_line1{
    display:flex;
    flex-flow:  row nowrap;
    align-items: center;
    justify-content: space-between;
}
.rowleft_line2{
    margin-top:10px;
    display:flex;
    flex-flow:  row nowrap;
    align-items: center;
    justify-content: space-between;
}
.drugname{
    font-size:18px;
    color:#333333;
}
.money{
    font-size:16px;
    color:red;
    margin-right:10px;
}
.drugspec{
    font-size:14px;
    color:#ACACAC;
}
.rowright{
    margin-left:auto;
    width:20px;
    display:flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
}
.rarrow{
    font-size:20px;
}
#points{background-color:#F6F6F6;min-height: 100vh;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;padding-bottom: 50px;}
.panel{display: flex;flex-flow: column nowrap;border-radius: 0.2rem;background-color: #fff;padding: 0.35rem;}
.part1{display: flex;flex-flow: column nowrap;}
.part1-line{font-size: 0.5rem; text-align: center;padding: 0.12rem;}
.smallfont{font-size: 0.35rem;}
.part2{display: flex;flex-flow: row wrap;width:100%;}
.part2-col{display: flex;flex-flow: column nowrap;width:33.3%;font-size:0.4rem;text-align: center;padding: 0.12rem;}
.part2-col4{display: flex;flex-flow: column nowrap;width:33.3%;font-size:0.4rem;text-align: center;padding: 0.12rem;}

.part3{display: flex;font-size:0.35rem;margin: 0.2rem 0;padding: 0.1rem;align-items: center;}
.txwords{padding: 0.1rem;}
.txbtn{margin-left: auto;padding: 0.15rem;background-color:#ee0a24;color:#fff;border-radius: 0.15rem;}
.part4{display: flex;flex-flow: column nowrap;}
.part4-line1{font-size:0.35rem;padding: 0.1rem;}
.part4-line2{display: flex;flex-flow: row nowrap;}
.part4-col{display: flex;flex-flow: column nowrap;font-size: 0.35rem;flex:0 0 33.3%;text-align: center;}
.part5-col{display: flex;flex-flow: column nowrap;font-size: 0.35rem;flex:0 0 50%;text-align: center;}

.split{height: 1px;width:100%;background-color: #ccc;}

.part5-col-right{margin-left:auto;}
.hint{font-size:16px;}
.dateinput{
    width:130px;
    height:30px;
    margin:0 5px;
    background-color: #ffffff;
    color:#E2A05E;
    padding:5px;
    font-size:18px;
    text-align: center;
}
.fc{
    justify-content: center;
}
.bottompart{
    width:100%;
    height:60px;
    background-color: #ffffff;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    position: fixed;
    left:0;
    bottom:0;
}
.rightpart{
    margin-left:auto;
    margin-right:15px;
}
.leftpart{
    margin-left:15px;
}
.totalnums{
    font-size:20px;
    color:#000000;
}
.rtotal{
    font-size:20px;
    color:#000000;
}
.rnumber{
    font-size:20px;
    color:red;
}
.ntitle{
    font-size:16px;
    color:#333333;
}
.ml{
    margin-left:25px;
}
.fr{
    margin-left:auto;
    margin-right:15px;
}
.mtb{
    margin-top:5px;
    margin-bottom:5px;
}
.sxbtn{
    width:100px;
    height:35px;
    display:flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    font-size:14px;
    background-color: #07C160;
    color:#fff;
}
</style>


